import { observer } from 'mobx-react-lite'
import {
  type CheckoutViewModel,
  type BillingMethodViewModel,
} from '@/features/jobs/drafting/checkout/CheckoutViewModel'
import {
  Payment,
  PaymentCardForm,
  PaymentMethodItem,
  PaymentMethodList,
} from '@/features/jobs/drafting/checkout/components/Checkout/Payment'
import { CardPaymentMethodFormContainer } from '@/features/jobs/drafting/checkout/components/Checkout/Payment/CardPaymentMethodFormContainer'
import { LoadingOverlay } from '@/components/LoadingOverlay'
import { ErrorBlock } from '@/components/ErrorBlock'

export interface PaymentContainerProps {
  vm: CheckoutViewModel
}

export const PaymentContainer = observer(function PaymentContainer({
  vm,
}: PaymentContainerProps) {
  return vm.fetch.match({
    pending: () => <LoadingOverlay />,
    resolved: () => (
      <Payment
        methodList={
          vm.paymentMethods && (
            <PaymentMethodList>
              {vm.paymentMethods.map((pm) => (
                <PaymentMethodItemContainer key={pm.id} vm={pm} />
              ))}
            </PaymentMethodList>
          )
        }
        hasPaymentMethods={Boolean(vm.hasPaymentMethods)}
        cardForm={
          vm.cardPaymentMethodFormVm && (
            <PaymentCardForm stripe={vm.cardPaymentMethodFormVm.stripe}>
              <CardPaymentMethodFormContainer vm={vm.cardPaymentMethodFormVm} />
            </PaymentCardForm>
          )
        }
      />
    ),
    rejected: (err) => <ErrorBlock error={err} />,
  })
})

interface PaymentMethodItemContainerProps {
  vm: BillingMethodViewModel
}

const PaymentMethodItemContainer = observer(
  function PaymentMethodItemContainer({ vm }: PaymentMethodItemContainerProps) {
    return (
      <PaymentMethodItem
        type={vm.type}
        title={vm.title}
        brand={vm.brand}
        last4={vm.last4}
        expires={vm.expires}
        isSelected={vm.selected}
        onPress={vm.toggleSelected}
      />
    )
  },
)
